module.exports = __webpack_public_path__ + "img/jcb.1b34892b.svg";